import React, { Fragment, forwardRef } from 'react';
import { ChevronRight } from 'lucide-react';
import { cx } from '../utils';
import './StepChain.css';

// Bosqichlar zanjiri (masalan kurs tayyorlash jarayoni).
// steps: [{ key?, label, count?, status?: 'done' | 'current' | 'todo' }]
const StepChain = forwardRef(function StepChain({ steps = [], className, ...rest }, ref) {
  return (
    <ol {...rest} ref={ref} className={cx('ui-steps', className)}>
      {steps.map((step, index) => (
        <Fragment key={step.key ?? step.label}>
          <li className={cx('ui-steps__item', `ui-steps__item--${step.status || 'todo'}`)}>
            <span className="ui-steps__num" aria-hidden="true">{index + 1}</span>
            <span className="ui-steps__label">{step.label}</span>
            {step.count !== undefined && step.count !== null && (
              <span className="ui-steps__count">{step.count}</span>
            )}
          </li>
          {index < steps.length - 1 && (
            <li className="ui-steps__arrow" aria-hidden="true">
              <ChevronRight />
            </li>
          )}
        </Fragment>
      ))}
    </ol>
  );
});

export default StepChain;
